<template>
  <div>
    <DataTable
      ref="datatable"
      :settings="datatable.settings"
      :dataColumns="datatable.columns"
      :dataFeed="datatable.dataFeed"
      :dataHandle="datatable.handle"
      :dataTableHeight="datatable.height"
      :defaultSortBy="datatable.sortBy"
      :defaultOrderBy="datatable.orderBy"
      :customSelectItem="selectItem"
      :customUnselectItem="unselectItem"
      :customAfterDeleteEvent="unselectItem"
      :allowView="allowView"
      :allowEdit="allowEdit"
      :allowDelete="allowDelete"
      :hasContextMenu="hasContextMenu"
    >
      <template slot="menuButtons" slot-scope="props">
        <template v-if="props.item && props.item.data">
          <li
            @click="$refs.datatable.viewItem($event, props.item.data)"
            v-if="allowView(props.item.data)"
          >View</li>
          <li
            @click="$refs.datatable.editItem($event, props.item.data)"
            v-if="allowEdit(props.item.data)"
          >Edit</li>
          <li
            @click="$refs.datatable.confirmDelete($event, props.item.data)"
            v-if="allowDelete(props.item.data)"
          >Delete</li>
        </template>
      </template>
    </DataTable>

    <StockHistory :selectedVendorProject="selectedVendorProject" v-if="selectedVendorProject" @reloadParent="reloadParent"/>

    <ImportModule 
      ref="importModule"
      @reload="reload"
      :uploadURL="$root.WebService.samplestock + '/import/upload'" 
      :confirmURL="$root.WebService.samplestock + '/import/confirm'"/>

  </div>
</template>
<script>

import ImportModule from 'src/components/ImportModule'
import exportData from 'src/global/exportData.js'
import importData from 'src/global/importData.js'

import StockHistory from './StockHistory/StockHistory'

export default {
  name: "SampleStock",
  components: {
    StockHistory,
    ImportModule
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Sample Stock',
        sectionName: 'samplestock',
        sectionIcon: 'fab fa-buffer',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.samplestock,
        navigation: [
          { name: 'Sample Stock', route: 'samplestock.index' },
        ],
        buttons: [],
        subSidebar: {
          buttons: [

          ]
        }
      },
      datatable: {
        settings: {
          sectionName: "samplestock",
          webService: this.$root.WebService.samplestock
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'ref_no', title: "Ref No.", type: "input", width: '15%', value: null },
          { key: 'hs_part_no', title: "HS Part No", type: "input", width: '25%', value: null },
          { key: 'vendor_short_name', title: "Vendor Short Name", type: "input", width: '15%', value: null },
          { key: 'stock_total', title: "Stock", type: "input", width: '15%', value: null },
          { key: 'stock_last_update', title: 'Stock Last Update Date', type: 'datepicker', width: '30%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },        ],
        sortBy: null,
        orderBy: "desc",
        height: "70vh",
      },
      datas: [],
      filteredDatas: [],
      isEditing: false,
      selectedVendorProject: null,
      formMode: null,
      exportFunction: {
        url: this.$root.WebService.samplestock + '/export',
        fileName: 'ExportSampleStock'
      },
    };
  },
  mounted() {

    if( this.hasPermission('import samplestock') ) this.pageSettings.buttons.push({ name: 'Import', icon: 'fas fa-file-upload', action: this.importData })
    if( this.hasPermission('export samplestock') ) this.pageSettings.buttons.push({ name: 'Export', icon: 'fas fa-file-download', action: this.exportData })

    this.$emit('setPageHeader', this.pageSettings)

    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.pageSettings.webService
    }
  },
  methods: {
    selectItem(item, key) {
      if (!this.hasPermission('read samplestock')) return

      this.$refs.datatable.filteredDatas = [item]
      this.$refs.datatable.page = 1
      this.$refs.datatable.remain = 1
      this.$refs.datatable.$refs.virtualList.forceRender()
      
      this.selectedVendorProject = item
    },
    unselectItem(item, key) {
      this.selectedVendorProject = null

      this.$refs.datatable.doFilter()
      this.$refs.datatable.page = this.$refs.datatable.previousPage
      this.$refs.datatable.remain = null
      this.$refs.datatable.$refs.virtualList.forceRender()
    },
    showModalVendorContact(item) {
      this.selectedVendor = item
    },
    addItem() {
      //this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData,
    importData,
    allowView(item) {
      return this.hasPermission('read samplestock') && 1 == 2
    },
    allowEdit(item) {
      return item.id !== 1 && this.hasPermission('update samplestock') && 1 == 2
    },
    allowDelete(item) {
      return item.id !== 1 && this.hasPermission('delete samplestock') && 1 == 2
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    reloadParent(evt, item) {
      this.$refs.datatable.reset()
    },
    reload() {
      this.$refs.datatable.reload()
    }
  }
};
</script>